<template>
  <div class="index">
    <div class="banner">
     <img  alt="banner" :src="config.banner">
     <div class="binding">你好，请先<span>【绑定账号】</span></div>
    </div>
    <div class="everyday">
      <div class="title">{{config.daily_prize_title}}</div>
      <div class="img-container">
        <img :src="dailyReward[0] && dailyReward[0].reward_image" alt="">
      </div>
      <div class="sign-btn">{{config.signin_btn_text}}</div>
      <span class="txt">{{config.signin_day_text}}</span>
    </div>
    <div class="added" v-if="rewards.length">
      <div class="title">{{config.accumulate_prize_title}}</div>
      <div v-for='(row, index) in rewards' v-bind:key='index'>
      <ul>
        <li v-for='(reward, idx) in row' v-bind:key='idx'>
          <div class="img-container">
            <img :src="reward.reward_image" alt="">
          </div>
          <div class="dayNum">{{reward.signin_count}}天</div>
        </li>
      </ul>
      </div>
      <div class="sign-btn" v-if="config.game_link"><a :href="config.game_link">进入游戏</a></div>

    </div>

    <div class="rules">
      <div class="title">{{config.rule_title}}</div>
      <div class="content" v-html="config.rule_content">
      </div>
    </div>


  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'index',
  data() {
    return {
      loading: false,
      config: {},
      dailyReward: [],
      rewards: [],
      id: this.$route.query.id,
    }
  },
  computed: {
  },
  created() {
    this.getTem()
  },
  methods: {
    getTem() {
      api.getTemplate({
        id: this.id,
      }).then((res) => {
        this.config = res

        const data = res.rewards.filter(reward => reward.reward_type === 2)
        this.dailyReward = res.rewards.filter(reward => reward.reward_type === 1)
        for (let i = 0, len = data.length; i < len; i += this.config.column_num) {
          this.rewards.push(data.slice(i, i + this.config.column_num))
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  },
}
</script>

<style lang="scss" src="./preview.scss" scoped></style>
